//export default class Offer {
//   constructor() {  
//     this.$sections = document.querySelectorAll('section.offer');  
//   }
//}
//
//new Offer();

import AOS from 'aos';
import 'aos/dist/aos.css'; 
import simpleParallax from 'simple-parallax-js';

document.addEventListener("DOMContentLoaded", () => {
    AOS.init();

    var image = document.querySelectorAll('.parallax-image')
    new simpleParallax(image, {
        orientation: 'up',
        overflow: true,
        delay: .6,
    });
});
